import { FormatLabelStringFn } from '@@partner:types:app'
import { TEXT_CATEGORY } from '@hive/status'


export const formatTextMaterialCategoryStatus: FormatLabelStringFn = (status: string) => {
  switch (status) {
  case TEXT_CATEGORY.ACTIVE:
    return { label: 'Активен', color: 'orange' }
  case TEXT_CATEGORY.DISABLED:
    return { label: 'Отключен', color: 'cyan' }
  case TEXT_CATEGORY.HIDDEN:
    return { label: 'Скрыт', color: undefined }
  default:
    return { label: 'Неизвестный статус', color: 'red' }
  }
}